import {Component, HostListener, OnInit} from '@angular/core';
import {UserData} from "../../models/user-data";
import {Account} from "../../core/auth/account.model";
import {AccountService} from "../../core/auth/account.service";
import {NotificheService} from "../../services/notifiche.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Canale} from "../../models/canale";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";

@Component({
  selector: 'jhi-message-settings',
  templateUrl: './message-settings.component.html',
  styleUrls: ['./message-settings.component.scss']
})
export class MessageSettingsComponent extends SubscriptionManager implements OnInit {
  account: Account | null = null;
  isUserRole?: boolean = false;
  userData!: UserData;
  canaleForm!: FormGroup;
  windowSize!: number;
  canale: Canale [] = []

  constructor(private accountService: AccountService, private notificheservice: NotificheService, private fb: FormBuilder) {
    super();
    this.windowSize = window.innerWidth;
    this.canaleForm = this.fb.group({
      canale: ""
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.windowSize = event.target.innerWidth;
  }

  ngOnInit(): void {
    this.ricercaCanaliPreferenza();
    this.userData = JSON.parse(localStorage.getItem("userData") ?? '{}');
    this.isUserRole = false;

    this.subs.sink = this.accountService.identity().subscribe(account => (this.account = account));

    // eslint-disable-next-line eqeqeq
    if (this.account?.authorities.includes("ROLE_USER")) {
      this.isUserRole = true;
    }
  }

  cambioPreferenzaON(event: any, value: string): void {
    if (event.target.checked) {
      this.canaleForm.patchValue({
        canale: value,
      });
      this.subs.sink = this.notificheservice.cambioPreferenzaON(value).subscribe({});
    } else {
      this.canaleForm.patchValue({
        canale: "CD-4",
      })
      this.cambioPreferenzaOFF(this.canaleForm.controls['canale'].value);
    }
  }

  cambioPreferenzaOFF(value: string): void {
    this.canaleForm.patchValue({
      canale: value
    });
    this.subs.sink = this.notificheservice.cambioPreferenzaOFF(value).subscribe({});
  }

  ricercaCanaliPreferenza(): void {
    this.subs.sink = this.notificheservice.ricaercaCanali().subscribe({
      next: (res) => {
        this.canale = res;
        this.updateToggle('EMAIL', 'Email');
        this.updateToggle('IO', 'AppIo');
      }
    });
  }

  updateToggle(tipoCanale: string, toggleId: string): void {
    const canale = this.canale.find(can => can.tiCanale === tipoCanale);
    if (canale) {
      const toggleElement = document.getElementById(toggleId);
      if (toggleElement) {
        if (canale.active) {
          toggleElement.setAttribute('checked', 'true');
        } else {
          toggleElement.removeAttribute('checked');
        }
      }
    }
  }
}
